import axiosClient from '@/api/axiosClient'
import { IProduct, IProductConfiguration } from '@/types'

interface ProductsResponse {
  products: IProduct[]
}

// The service wraps the list in `data`, as the other support endpoints do —
// not the `productConfigurations` key the ticket's draft schema showed.
interface ProductConfigurationsResponse {
  data: IProductConfiguration[]
}

export const ProductService = {
  fetchProducts: async (): Promise<IProduct[]> => {
    const response = await axiosClient.get<ProductsResponse>('/products')

    return response.data.products
  },

  // Not customer-scoped: product configurations and their eligibility rules are
  // global. VITE_API_BASE_URL already ends in /support, so the full path is
  // /support/product-configurations.
  fetchProductConfigurations: async (): Promise<IProductConfiguration[]> => {
    const response = await axiosClient.get<ProductConfigurationsResponse>(
      '/product-configurations'
    )

    return response.data.data ?? []
  },
}
